export enum FileOptions {
  AddCoverPage = 'Add cover page',
  OneInvoicePerEmail = 'One invoice per email',
  OneProPerPDF = 'One PRO per PDF',
  RenameFilename = 'Rename File (9 digit PRO)'
}
